import { render, staticRenderFns } from "./role_manage.vue?vue&type=template&id=0f5a109e&scoped=true&"
import script from "./role_manage.vue?vue&type=script&lang=js&"
export * from "./role_manage.vue?vue&type=script&lang=js&"
import style0 from "./role_manage.vue?vue&type=style&index=0&id=0f5a109e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5a109e",
  null
  
)

export default component.exports